import React from 'react';

//redux
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";

import defaults from '../../configuration/defaults';

import {updateFilter, clearFilter} from '../../actions/selectedFilters';
import {toggleFilters} from "../../actions/toggleFilters";

import FilterCheckButtonNextDay from '../filterCheckButtonNextDay';

import {backForwardRefreshNavigation, updateFilterStore, getSelectedFilterCount} from '../../services/utilities';
import fetchFilters from "../../services/filtersService";

import {initGa, onclickGAEvent} from '../../middleware/googleAnalytics';

import _ from "lodash";

import grid from '../../modules/Grid.module.scss';
import card from "../../modules/Cards.module.scss";
import spacing from '../../modules/Spacing.module.scss';
import styles from '../../modules/Filters.module.scss';

import FilterContainer from "../filterContainer";
import FiltersPlaceholder from "../placeholder/filters";

export class Index extends React.Component {

    initGa = initGa;
    defaults = defaults;
    backForwardRefreshNavigation = backForwardRefreshNavigation;
    fetchFilters = fetchFilters;
    window = window;

    constructor(props) {
        super(props);

        this.categoryPath = defaults.categoryPath;
        this.apiUrl = defaults.apiUrl;

        this.filterOptionsRef = React.createRef();
        this.filterContainerRef = React.createRef();

        this.state = {
            isLoading: false, currentOpenFilter: null, filters: []
        };
    }

    componentDidMount() {
        this.initGa();
        this.reloadFilters(false);
    }

    componentDidUpdate(prevProps) {

        if (!_.isEqual(this.props.selectedFilters, prevProps.selectedFilters)) {
            this.fetchFilters(this.getFilterStore(), this.apiUrl, this.getFilterQuery()).then(result => {
                const filters = result.data;

                this.setState({
                    filters: filters, isLoading: false
                });
            });
        }
    }

    reloadFilters = () => {
        const selectedFilters = this.getMountFilters();
        const query = this.getFilterQuery();

        this.loadingFilters(true);
        this.fetchFilters(
            selectedFilters,
            this.apiUrl,
            query
        ).then(result => {
            const filters = result.data;

            let updatedFilters = _.cloneDeep(selectedFilters);
            if (query.cr) {
                //if a share link is passed, reset
                updatedFilters.filters = {};
            }

            for (const filter of filters) {

                if (typeof (filter.data) !== "undefined" && filter.data !== null) {

                    let filterData = [];

                    if (Array.isArray(filter.data)) {
                        filterData = filter.data;
                    } else {
                        filterData = [{
                            ...filter, ...filter.data,
                        }]
                    }

                    for (const item of filterData) {

                        if (typeof (item.checked) !== "undefined" && typeof (item.value) !== "undefined" && item.checked === true && item.value !== '') {
                            const newFilterStore = updateFilterStore(updatedFilters, item, this.categoryPath, filter.name);

                            if (newFilterStore) {
                                updatedFilters = newFilterStore;
                            }
                        }
                    }
                }
            }

            if (updatedFilters && !_.isEqual(selectedFilters, updatedFilters)) {
                this.props.updateFilter(updatedFilters);
            }

            this.setState({
                filters: filters,
                isLoading: false,
            });
        }).catch(() => {
            this.loadingFilters(false);
        });
    }

    searchTermHasChanged() {
        if (this.defaults.keywords) {
            const startingFilters = this.props.selectedFilters;

            let selectedFilters = {};
            if (startingFilters && this.categoryPath in startingFilters) {
                selectedFilters = startingFilters[this.categoryPath];
            }

            return selectedFilters.keywords !== this.defaults.keywords;
        } else {
            return false;
        }
    }

    getMountFilters() {
        if (this.backForwardRefreshNavigation() && !this.searchTermHasChanged()) {
            return this.getFilterStore();
        } else {
            // don't need to clear the filters if a share link is provided
            if (!this.defaults.shareLink) {
                this.clearFilterStore();
            }
            return {
                categoryPath: this.categoryPath, keywords: this.defaults.keywords, filters: {}
            }
        }
    }

    getFilterQuery() {
        let query = {}
        /**
         * Pushing into the navigation history, makes the browser think that clicking the quick link is a "reload".
         * So we need to be able to force the CR link into the query params.
         */
        if (this.defaults.shareLink) {
            query.cr = this.defaults.shareLink;
        }

        const params = new URLSearchParams(this.window.location.search);
        const clearCache = params.get('clearCache') === 'true';

        if (clearCache) {
            query.clearCache = 'true';
        }

        return query;
    }

    updateFilterStore(item, filterName) {
        const selectedFilters = this.getFilterStore();

        const filter = updateFilterStore(selectedFilters, item, this.categoryPath, filterName);
        if (filter) {
            this.props.updateFilter(filter);
        }
    }

    onFilterChange = (filterName, filter) => {
        //update filter store
        this.updateFilterStore(filter, filterName);

        if (!this.props.filtersVisible) {
            this.setState({currentOpenFilter: null});
        }
    };

    clearFilterStore() {
        let renderFilters = this.getSelectedFilters(true);
        const hasSelectedFilters = renderFilters && Object.keys(renderFilters).length > 0;

        if (hasSelectedFilters) {
            this.props.clearFilter(this.categoryPath);
        }
    }

    onClearAllFilters = () => {
        this.clearFilterStore();
    }

    loadingFilters = (state = true) => {
        this.setState({isLoading: state});
    }

    closeFilterContainer = (name) => {
        if (this.state.currentOpenFilter && name === this.state.currentOpenFilter) {
            this.setState({currentOpenFilter: null});
        }
    }

    filterOptionClick = (e, filter) => {
        if (this.state.currentOpenFilter === filter.label) {
            if (e.target.dataset.back === 'true') {
                this.setState({currentOpenFilter: null});
            }
        } else {
            this.setState({currentOpenFilter: filter.label});
        }
    }

    createFilterList = () => {
        const {currentOpenFilter, filters} = this.state;

        return filters.map(filter => {

            if (filter.data !== null && filter.type === 'filterList') {
                if (!this.shouldBeDisplayed(filter)) {
                    return null;
                }

                return (<div
                    key={'filter-' + filter.name}
                    className={`${styles.option} ${grid.col12} ${grid.colSm6} ${grid.colMd4} ${grid.colLg2} ${grid.colXl2}`}>
                    <div
                        onClick={(e) => this.filterOptionClick(e, filter)}>
                        <FilterContainer
                            key={filter.name}
                            filtersVisible={this.props.filtersVisible}
                            filterName={filter.label}
                            filterOptions={filter.data}
                            open={currentOpenFilter === filter.label}
                            onChange={this.onFilterChange.bind(this, filter.name)}
                            closeFilterContainer={this.closeFilterContainer}
                            loadingFilters={this.loadingFilters}
                            onclickGAEvent={onclickGAEvent}
                        />
                    </div>
                </div>)
            } else {
                return null;
            }
        });
    }

    shouldBeDisplayed = (filter) => {
        let count = 0;
        filter.data.forEach(element => {
            if (element.value !== '' && !element.disabled) {
                count++;
            }
        });

        return (count > 0);
    }

    getFilterStore() {
        const startingFilters = this.props.selectedFilters;

        let selectedFilters = false;
        if (startingFilters && this.categoryPath in startingFilters) {
            selectedFilters = startingFilters[this.categoryPath];
        }

        const defaultFilters = {
            categoryPath: this.categoryPath, keywords: defaults.keywords, filters: {}
        };

        if (selectedFilters) {
            return {
                ...selectedFilters, categoryPath: this.categoryPath, keywords: defaults.keywords
            }
        }

        return defaultFilters;
    }

    getSelectedFilters(includingNonStandard = false) {
        const selectedFilters = this.getFilterStore();
        let renderFilters = {};

        const filterExclude = includingNonStandard ? [] : ['es', 'ns', 'has_next_day'];

        //selected filters minus next day and sort order
        Object.keys(selectedFilters.filters).forEach(key => {
            if (!filterExclude.includes(key)) {
                renderFilters[key] = selectedFilters.filters[key];
            }
        });

        return renderFilters;
    }

    filtersVisible() {
        return this.props.filtersVisible ? styles.filtersOpen : '';
    }

    clearAllFilters = (e) => {
        e.preventDefault();
        this.onClearAllFilters();
        this.loadingFilters(true);
        onclickGAEvent({
            action: 'Text Link', label: 'Click here to reset all filters',
        })
    }

    renderNextDayOption() {
        const {filters} = this.state;
        const selectedFilters = this.getFilterStore();

        const filterName = this.defaults.isProductApi ? 'has_next_day' : 'es';

        return (<div className={styles.selectedFiltersInput}>
            <FilterCheckButtonNextDay
                key='NextDayProducts'
                onChange={this.onFilterChange.bind(this, filterName)}
                loadingFilters={this.loadingFilters}
                filters={filters}
                checked={!!(selectedFilters.filters.es || selectedFilters.filters.has_next_day)}
                onclickGAEvent={onclickGAEvent}
            />
        </div>)
    }

    renderClearAllFilters(renderFilters) {
        if (Object.keys(renderFilters).length > 0) {
            return <div className={styles.headerClearAll} onClick={this.clearAllFilters}>Clear all</div>;
        }
    }

    clickOutsideTest = (e) => {
        const container = this.filterContainerRef.current;
        const options = this.filterOptionsRef.current;

        if (e.target === container && e.clientX > options.offsetWidth) {
            this.props.toggleFilters();
        }
    }

    render() {
        let renderFilters = this.getSelectedFilters();
        const hasSelectedFilters = renderFilters && Object.keys(renderFilters).length > 0;
        if (Object.keys(this.state.filters).length === 0) {
            return (
                <div className={`${styles.filterOptionsBody}`} data-testid={"no-products"}>
                    <FiltersPlaceholder className={`${styles.filterOptions}`}/>
                    <div className={styles.selectedFiltersContainer}>
                        <div className={styles.selectedFiltersInput}>
                            <div>
                                <div style={{height: 32}}></div>
                            </div>
                        </div>
                        <div className={grid.flexGrid} style={{
                            height: "62px"
                        }}>
                        </div>
                    </div>
                </div>
            );
        }

        return (<div className={this.filtersVisible()} onClick={this.clickOutsideTest} ref={this.filterContainerRef}>
            <div className={`${card.card} ${card.cardNoBorder} ${styles.filterOptions}`}
                 ref={this.filterOptionsRef}>
                <div className={styles.filterOptionsHeader}>
                    {this.renderClearAllFilters(renderFilters)}
                    Filters {getSelectedFilterCount(this.getSelectedFilters())}
                </div>
                <div className={`${spacing.mb3} ${styles.filterOptionsBody}`}>
                    {this.state.isLoading && <div className={styles.loadingFilters}></div>}
                    {this.props.filtersVisible && (<div className={`${styles.option} ${styles.nextDayOption}`}>
                        {this.renderNextDayOption()}
                    </div>)}
                    <div className={grid.flexGrid}>
                        {this.createFilterList()}
                    </div>
                    <div className={styles.selectedFiltersContainer}>
                        {!this.props.filtersVisible && this.renderNextDayOption()}
                        <div className={styles.selectedFiltersList}>
                            {hasSelectedFilters && <>
                                <span>Selected Filters: </span>
                                <button
                                    className={styles.clearAll}
                                    onClick={this.clearAllFilters}>
                                    Clear All
                                </button>
                                {Object.keys(renderFilters).map(key => {
                                    const filter = renderFilters[key];

                                    return (<span
                                        className={styles.selectedFilter}
                                        key={'selected-filter-' + key.toString()}>
                                                        {filter.label}
                                        <span
                                            className={styles.closeIcon}
                                            title={'remove this filter'}
                                            onClick={e => {
                                                e.preventDefault();
                                                this.onFilterChange(filter.filterName, {
                                                    name: key, checked: false
                                                });
                                                this.loadingFilters(true);
                                            }}
                                        > </span>
                                    </span>)
                                })}
                            </>}
                        </div>
                    </div>
                </div>
                <div className={styles.filterOptionsFooter}
                     data-testid="mobile-view-products"
                     onClick={this.props.toggleFilters}>
                    View products
                </div>
            </div>
            <div className={styles.closeFilters}
                 onClick={this.props.toggleFilters}>
                <em className="icon-ecom-times"> </em>
            </div>
        </div>)
    }
}

Index.propTypes = {
    updateFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    toggleFilters: PropTypes.func,
    selectedFilters: PropTypes.object,
    filtersVisible: PropTypes.bool,
}

function mapStateToProps(state) {
    return {
        selectedFilters: state.selectedFilters, filtersVisible: state.filtersVisible
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateFilter, clearFilter, toggleFilters
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
